export const cheatCopy = {
    cht_layout_title: "Cheat Sheets",
    cht_layout_description:
        "Cheat Sheets covering TypeScript syntax.",
    cht_download: "Download Zip",
    cht_blurb_1: "Downloadable syntax reference pages for different parts of everyday TypeScript code",
    cht_blurb_2: "Learn more about Classes, Interfaces, Types and Control Flow Analysis",

    cht_cfa: "Control Flow Analysis",
    cht_interfaces: "Interfaces",
    cht_types: "Types",
    cht_classes: "Classes",
    cht_dl_title: "Download PDFs and PNGs",
    cht_dl_subtitle: "To read later or print",
}
